module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "label": _vm.label,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.studentList), function(student) {
    return _c('Option', {
      key: student.id,
      attrs: {
        "value": student.id
      }
    }, [_vm._v("\n    " + _vm._s(student.id) + " - " + _vm._s(student.nickname) + "\n  ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d7c0bb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StudentSelect.vue
// module id = 1621
// module chunks = 8